import * as React from 'react';
const LogoCore = (props) => {
    const { className, components: { Anchor }, onClick, size, text, url, target, } = props;
    const BEM = () => {
        const classArray = ['logo'];
        if (size) {
            classArray.push(`logo--${size}`);
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (React.createElement("div", { className: BEM() }, url ? (React.createElement(Anchor, { url: url, className: "logo__img", onClick: onClick, target: target },
        React.createElement("span", { className: "logo__text" }, text))) : (React.createElement("span", { className: "logo__img" },
        React.createElement("span", { className: "logo__text" }, text)))));
};
export { LogoCore as default };
